import React from 'react'
import { storiesOf } from '@storybook/react'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import CurrentIndexFaC from '.'

// Story Setup
const stories = storiesOf('Digital-Commons/Facc-Current-Index', module)

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const _onCurrentIndexChanged = idx => {
  console.log('new index', idx)
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <CurrentIndexFaC
        onCurrentIndexChanged={_onCurrentIndexChanged}
        totalItems={5}
        infinite={false}
      >
        {
          ({ currentIndex, currentIndexProps }) => {
            return (
              <div>
                <button onClick={currentIndexProps.prevHandler}>Decrement</button>
                <button onClick={currentIndexProps.nextHandler}>Increment</button>
                <button onClick={() => currentIndexProps.setIndex(3)}>Set to 3</button>
                <p>Current Index: {currentIndex}</p>
              </div>
            )
          }
        }
      </CurrentIndexFaC>
    </ThemeProvider>
  ))
